var _rect, _path, _rect2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFront5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 10,
    fill: "#FFE6C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 9.5H23.0333C25.6469 9.5 26.9537 9.5 27.952 10.0086C28.83 10.456 29.544 11.17 29.9914 12.048C30.5 13.0463 30.5 14.3531 30.5 16.9667V25.25M13.2333 30.5H22.6833C23.9901 30.5 24.6435 30.5 25.1426 30.2457C25.5817 30.022 25.9386 29.665 26.1623 29.226C26.4167 28.7269 26.4167 28.0735 26.4167 26.7667V17.3167C26.4167 16.0099 26.4167 15.3565 26.1623 14.8574C25.9386 14.4183 25.5817 14.0614 25.1426 13.8377C24.6435 13.5833 23.9901 13.5833 22.6833 13.5833H13.2333C11.9265 13.5833 11.2731 13.5833 10.774 13.8377C10.335 14.0614 9.97802 14.4183 9.75432 14.8574C9.5 15.3565 9.5 16.0099 9.5 17.3167V26.7667C9.5 28.0735 9.5 28.7269 9.75432 29.226C9.97802 29.665 10.335 30.022 10.774 30.2457C11.2731 30.5 11.9265 30.5 13.2333 30.5Z",
    stroke: "#A26A1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#F9C579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1667 35.3333L31.1667 27M27 31.1667H35.3333",
    stroke: "#A26A1A",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFront5);
export default __webpack_public_path__ + "static/media/front-5.1d25e8b669004722c3eedf941e5a43d7.svg";
export { ForwardRef as ReactComponent };